var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "app"
    }
  }, [_c("transition", {
    attrs: {
      name: _vm.transitionName
    }
  }, [_c("keep-alive", {
    attrs: {
      include: "Country"
    }
  }, [_c("router-view", {
    staticClass: "Router"
  })], 1)], 1), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.onLine,
      expression: "!onLine"
    }],
    staticClass: "errPage"
  }, [_c("div", {
    staticStyle: {
      padding: "0 25px",
      height: "54px",
      display: "flex",
      "justify-content": "space-between",
      "align-items": "center",
      "box-sizing": "border-box",
      "z-index": "99",
      "background-color": "#fff"
    }
  }), _c("div", {
    staticClass: "container"
  }, [_c("div", {
    staticClass: "Appointment_succeeded"
  }, [_vm._m(0), _c("div", {
    staticClass: "as-p"
  }, [_vm._v(_vm._s(_vm.$t("Sorry_No_network")))]), _c("div", {
    staticClass: "as-btn",
    on: {
      click: _vm.Refresh
    }
  }, [_vm._v(_vm._s(_vm.$t("Refresh")))])])])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "as-img"
  }, [_c("img", {
    attrs: {
      src: require("./assets/images/ic_no_network.png"),
      alt: ""
    }
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };